import React from "react"

import { MouthLaugh } from "./laugh"
import { MouthSmile } from "./smile"
import { MouthPeace } from "./peace"

const _Mouth = ({ style, isEditor }: { style: string; isEditor?: boolean }) => {
  switch (style) {
    case "laugh":
      return <MouthLaugh isEditor={isEditor} />
    case "smile":
      return <MouthSmile isEditor={isEditor} />
    case "peace":
    default:
      return <MouthPeace isEditor={isEditor} />
  }
}
export const Mouth = React.memo(_Mouth)
